export default "__VITE_ASSET__CZ73ymi1__"